import styled from '@emotion/styled';

export const ErrorContainer = styled.div`
	display: flex;
	justify-content: start;
	align-items: center;
	overflow: hidden;
	gap: 0.5rem;
	cursor: default;
	width: auto;
`;
